module.exports = __webpack_public_path__ + "img/hire_equipment2.38960333.jpg";